import {
  NOTICE_STORE_STATUS,
  NOTICE_STORE_TYPE,
  NOTICE_STORE_HOME_EXPOSURE_STATUS,
} from '../../../../constants/service/app/noticeStoreConstants';

/**
 *  상점 공지사항 리스트 필터 옵션 모델
 */
export const NOTICE_STORE_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상점 공지사항 상태
   */
  status: null,
  /**
   *  상점 공지사항 구분
   */
  type: null,
  /**
   *  홈 노출 여부
   */
  isHomeExposure: null,
  /**
   *  제목
   */
  title: null,
  /**
   *  작성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  상점 공지사항 리스트 필터 옵션 모델
 */
export const NOTICE_STORE_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  상점 공지사항 정보 모델
 */
export const NOTICE_STORE_INFO_MODEL = {
  /**
   *  상점 공지사항 구분
   */
  type: NOTICE_STORE_TYPE.GENERAL,
  /**
   *  제목
   */
  title: null,
  /**
   *  본문
   */
  content: null,
  /**
   *  상점 공지사항 라벨
   */
  labelList: [],
  /**
   *  상점 공지사항 상태
   */
  status: NOTICE_STORE_STATUS.NON_EXPOSURE,
  /**
   *  홈 노출 여부
   */
  isHomeExposure: NOTICE_STORE_HOME_EXPOSURE_STATUS.NON_EXPOSURE,
  /**
   *  상점 공지사항 첨부파일
   */
  attachment: [],
  /**
   *  상점 공지사항 url
   */
  url: {
    id: null,
    link: null,
  },
};
